































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message';
import { routingControlModule } from '../../store/modules/RoutingControl';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import router from '../../router';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class PasswordIssueResult extends ApiAccessBase {
  private acceptNo = applicationFormModule.GET_ACCEPT_NO;
  private path = UketsukeConstants.PASS_FORM_OUTPUT + '/formOutput/';

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.setVariablecolsState(['pass_form_output']);
  }

  /**
　  * ID及びパスワード送付書（XLSX）
　  */
  private excelDownload() {
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      this.path = UketsukeConstants.PASS_FORM_OUTPUT + '/formOutput/' + applicationFormModule.GET_APP_TYPE + '/' + applicationFormModule.GET_TRADER_ID;
      this.apiAccessDownload(this.path);
    }
  }

  /**
   * Topへ戻る
   */
  private backToTop() {
    // this.deleteExclusive();
    applicationFormModule.moduleResetDetail();
    router.push({name: UketsukeScreenName.UKETSUKE_ORDER_MAIN});
  }

  /**
   * 検索画面へ戻る
   */
  private backToSearch() {
    // this.deleteExclusive();
    applicationFormModule.moduleResetDetail();
    router.push({name: UketsukeScreenName.PASSWORD_ISSUER_SEARCH});
  }

  // /**
  //  * 排他ロック解除
  //  */
  // private deleteExclusive() {
  //   this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/delete/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_POST, false, true);
  // }
}
